import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { useTranslator } from '$hooks';
import { Loader } from '$shared/components';
import { Api } from '$api';
import router from '$navigation/router';
import { SETTINGS } from '$shared/constants/pages';
import { mainActions } from '$store/main';
import { dashboardActions } from '$store/dashboard';
import { feedActions } from '$store/feed';

export const BindEmailConfirm: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    const uid = searchParams.get('uid');
    if (!token || !email || !uid) {
      setErrorMessage(t('bind_email_confirm_invalid_link'));
      setStatus('error');
      return;
    }

    Api.post('/profile/email/bind/confirm', {
      token: token,
      email: email,
      uid: parseInt(uid),
    })
      .then(() => {
        dispatch(mainActions.setShouldBindEmail(false));
        dispatch(dashboardActions.loadDashboard());
        dispatch(feedActions.hideNotificationFromUI('bind_email'));
        setStatus('success');
      })
      .catch((error) => {
        setErrorMessage(error?.message || t('failed_title'));
        setStatus('error');
      });
  }, []);

  const handleContinue = () => {
    router.navigate(SETTINGS);
  };

  return (
    <>
      <Header>{t('bind_email_title')}</Header>
      <ScrollView>
        {status === 'loading' && <Loader isWrapped />}
        {status === 'success' && (
          <Placeholder title={t('bind_email_success')} centered>
            <Button size="small" onClick={handleContinue}>
              {t('bind_email_confirm_continue')}
            </Button>
          </Placeholder>
        )}
        {status === 'error' && (
          <Placeholder title={t('bind_email_confirm_error')} centered>
            {errorMessage}
          </Placeholder>
        )}
      </ScrollView>
    </>
  );
};
